import React from 'react';
import Navbar from '../components/navbar';
import Landing from '../components/landing';
import About from '../components/about';
import Footer from '../components/footer';
import Faq from "../components/faq";
import References from "../components/references";
import Framework from "../components/framework";
import Feature from "../components/feature";
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fal } from '@fortawesome/pro-light-svg-icons'
import { faAd } from '@fortawesome/pro-duotone-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'


library.add(fas, far, fal, faAd, fab);

class App extends React.Component {

	state = {
		language:  'HUN'
	};

	componentDidMount() {
		setTimeout(function () {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 2000);
		
		this.getUserData();
	}
	
	getUserData = () => {
		fetch("http://api.ipstack.com/check?access_key=fcfeee5b06032b3b677b1091d57f8f52")
			.then(res => res.json())
			.then(
				(result) => {
					const countryCode = result.country_code;
					if (countryCode !== 'HU')
					this.setState({
						language: 'ENG'
					});
				},
				(error) => {
					this.setState({
						language: 'HUN'
					});
				}
			);
	};
	
	handleLanguageChange = (lang) => {
		if (this.state.language !== lang) {
			this.setState({language: lang});
		}
	};

	render() {
		document.body.classList.remove('landing-page');
		document.body.classList.remove('home-style');
		document.body.classList.remove('three');
		document.body.classList.remove('home-style-two');
		
		return (
			<div>
				{/* Navbar Component*/}
				<Navbar language={this.state.language} onLanguageChange={(lang) => this.handleLanguageChange(lang)}/>

				{/* Landing Component*/}
				<Landing language={this.state.language}/>

				{/* About Component*/}
				<About language={this.state.language}/>

				{/*Framework Component*/}
				<Framework language={this.state.language}/>

				{/*References Component*/}
				<References language={this.state.language}/>

				{/*Products Component*/}
				<Feature language={this.state.language}/>

				{/*Career Component*/}
				<Faq language={this.state.language}/>

				{/*Contact Component*/}
				<Footer language={this.state.language}/>
			</div>
		);
	}
}

export default App;


// WEBPACK FOOTER //
// ./src/demo_page/index.js